// Auto-mounted by PersistentLayout. Don't import elsewhere —
// enforced by Biome's noRestrictedImports rule in biome.json.

import { usePage } from "@inertiajs/react";
import { showToast } from "@ui/components/Toast";
import { useEffect, useRef } from "react";
import { isFlashMessage, normalizeFlashValue, type SharedProps } from "@/types";

export function useFlashToasts() {
  const { flash } = usePage<SharedProps>().props;
  const processedRef = useRef<string | null>(null);

  useEffect(() => {
    const fingerprint = JSON.stringify(flash.toast);
    if (fingerprint === processedRef.current) return;
    processedRef.current = fingerprint;

    const notification = normalizeFlashValue(flash.toast);
    if (!notification) return;

    // Trust the status field unchecked: the toast primitive renders every
    // ToastStatus value. Alerts validate at runtime (see use-flash-alerts.ts)
    // because the alert primitive accepts a strict subset.
    const status = isFlashMessage(flash.toast) ? (flash.toast.status ?? "success") : "success";
    showToast({ title: notification.title, description: notification.description, status });
  }, [flash.toast]);
}
